import { useState } from "react";
import Landing from "./landing"
import Main from "./main";
import { Route, Routes } from "react-router-dom";
import RemoteControl from "./remoteControl";

export type Page = 'Landing' | 'Main'

const App = () => {
    const [page, setPage] = useState<Page>('Landing');
    
    return (
        <>
            <Routes>
                <Route path='*' element={
                    <>
                        {page === 'Landing' && <Landing setPage={(page) => setPage(page)}/>}
                        {page === 'Main' && <Main setPage={(page) => setPage(page)}/>}
                    </>}
                />
                <Route path='/remote' element={<RemoteControl/>}/>
            </Routes>
        </>
    )
}

export default App